import { HistoryOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { AbstractTooltipProps } from 'antd/lib/tooltip';
import React from 'react';
import styled from 'styled-components';

import { formatUTCTimeToLocal } from '../utils/format';

const XeroSyncHistory = (props: {
  history: {
    [key: string]: any;
  };
  placement?: AbstractTooltipProps['placement'];
}) => {
  const historyArr: Array<{
    SAID: number;
    xero_invoice_id: string;
    xero_attachments: any[];
    xero_sync_data: {
      reference_number: string;
      payment_status: string;
      operation_status: string;
    };
    xero_response: any;
    user_info: {
      user_id: number;
      email: string;
      full_name: string;
      phone_number: string;
    };
    timestamp: string;
  }> = Object.keys(props.history).reduce((arr, key) => {
    return [...arr, props.history[key]];
  }, []);

  return (
    <Popover
      title={
        <p style={{ margin: 0 }}>
          <HistoryOutlined /> History
        </p>
      }
      content={
        <HistoryUl>
          {historyArr.map(hist => (
            <li key={`${hist.SAID}-${hist.timestamp}`}>
              <p>
                <b>
                  {formatUTCTimeToLocal(hist.timestamp, 'HH:mm DD MMM YYYY')}
                </b>
              </p>
              <p>
                by {hist.user_info?.full_name} <i>({hist.user_info?.email})</i>
              </p>
              <p>ID: {hist.xero_invoice_id || '-'}</p>
              <p>
                {!hist.xero_attachments?.length
                  ? 'No Attachment'
                  : `${hist.xero_attachments.length} Attachment(s)`}
              </p>
            </li>
          ))}
        </HistoryUl>
      }
      placement={props.placement || 'bottom'}
    >
      <p style={{ margin: 0, textDecoration: 'underline' }}>
        <HistoryOutlined /> History
      </p>
    </Popover>
  );
};

const HistoryUl = styled.ul`
  margin: 0;
  padding: 0 0 0 15px;

  li {
    p {
      margin: 0;
    }
  }
`;

export default XeroSyncHistory;
